export default "__VITE_ASSET__CafLYWKA__"